import React from 'react';
import { FiX, FiMail, FiInstagram } from 'react-icons/fi';

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4 transition-opacity duration-300" onClick={onClose}>
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-md mx-auto p-6 transition-transform transform scale-100" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
          <FiX size={24} />
        </button>
        <div className="flex flex-col items-center text-center">
          <h2 className="text-2xl font-bold mb-4">ارتباط با ما</h2>
          <p className="text-gray-700 mb-3">
            ما همیشه مشتاق شنیدن نظرات، پیشنهادات و پرسش‌های شما هستیم. اگر در استفاده از درمو وایز به مشکلی برخوردید یا نیاز به راهنمایی بیشتری داشتید، تیم پشتیبانی ما آماده پاسخ‌گویی به شماست.
          </p>
          <p className="text-gray-700 mb-4">
            با ما در تماس باشید تا بتوانیم تجربه‌ی بهتری از مراقبت هوشمند پوست برایتان فراهم کنیم.
          </p>
          <a href="mailto:dermowiseai@gmail.com" className="mt-2 text-teal-600 hover:underline flex items-center space-x-2 rtl:space-x-reverse">
            <FiMail size={20} />
            <span>dermowiseai@gmail.com</span>
          </a>
          <a href="https://www.instagram.com/dermowise/" target="_blank" rel="noopener noreferrer" className="mt-2 text-pink-500 hover:underline flex items-center space-x-2 rtl:space-x-reverse">
            <FiInstagram size={20} />
            <span>@dermowise</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactModal; 